export const BASE_URL = process.env.REACT_APP_BASE_URL;

export const API_HEADER = {
  headers: {
    Authorization: localStorage.getItem("authToken"),
  },
};
